import { render, staticRenderFns } from "./CryptoNews.vue?vue&type=template&id=90a395c0"
import script from "./CryptoNews.vue?vue&type=script&lang=js"
export * from "./CryptoNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports